import styled from 'styled-components/macro';
import Breakpoints from 'themes/constants/breakpoints';

export const NavbarContainer = styled.div`
    display: flex;
    flex-flow: column nowrap;
    width: 100%;
    background: ${({ theme }) => theme.background.primary};
    z-index: 10000;
`;
export const NavbarInner = styled.div`
    display: flex;
    flex-flow: column nowrap;
    flex-grow: 1;
    padding: 6px 2px;
    line-height: 20px;
    @media only screen and (${Breakpoints.MOBILE_L}) {
      padding: 6px 12px;
    }
    @media only screen and (${Breakpoints.TABLET}) {
        ${({ theme }) => theme.paddings.inner.tablet};
    }
`;
export const NavbarList = styled.div`
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    gap: 5px;
`;
export const NavbarListItem = styled.div<{ isActive?: boolean }>`
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    flex-shrink: 0;
    width: calc((100% - 20px) / 5);
    padding: 8px 0;
    cursor: pointer;
    font-size: 10px;
    line-height: 1.2;
    text-transform: lowercase;
    color: ${({ isActive, theme }) => (isActive ? theme.palette.secondary : theme.palette.greyDark)};
    @media only screen and (${Breakpoints.MOBILE}) {
        font-size: 11px;
    }
    @media only screen and (${Breakpoints.MOBILE_M}) {
        width: 70px;
        font-size: 12px;
    }
`;
export const NavbarListItemIcon = styled.div<{ isActive?: boolean }>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    margin-bottom: 4px;
    height: 100%;
    & > svg {
        color: ${({ isActive, theme }) => (isActive ? theme.palette.secondary : theme.palette.greyDark)};
        width: 24px;
        max-width: 24px;
        max-height: 24px;
    }
`;
export const NavbarListItemText = styled.div`
  flex-shrink: 0;
  max-width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
